(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function initCarousel() {
    if (!window.matchMedia("(max-width: 768px)").matches) return;

    const track = document.querySelector('.carousel-track');
    const slides = Array.from(track.children);
    const prevButton = document.querySelector('.carousel-nav.prev');
    const nextButton = document.querySelector('.carousel-nav.next');

    if (!track || slides.length === 0 || !prevButton || !nextButton) return;

    // Clone first and last
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    firstClone.classList.add('clone');
    lastClone.classList.add('clone');
    track.appendChild(firstClone);
    track.insertBefore(lastClone, slides[0]);

    const allSlides = Array.from(track.children);
    let currentIndex = 1;

    let slideWidth = allSlides[currentIndex].getBoundingClientRect().width;

    function setPosition() {
      slideWidth = allSlides[currentIndex].getBoundingClientRect().width;
      track.style.transition = 'none';
      track.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
    }

    function goToSlide(index) {
      slideWidth = allSlides[index].getBoundingClientRect().width;
      track.style.transition = 'transform 0.3s ease-in-out';
      track.style.transform = `translateX(-${slideWidth * index}px)`;
    }

    setPosition();

    nextButton.addEventListener('click', () => {
      if (currentIndex >= allSlides.length - 1) return;
      currentIndex++;
      goToSlide(currentIndex);
    });

    prevButton.addEventListener('click', () => {
      if (currentIndex <= 0) return;
      currentIndex--;
      goToSlide(currentIndex);
    });

    track.addEventListener('transitionend', () => {
      if (allSlides[currentIndex].classList.contains('clone')) {
        track.style.transition = 'none';
        if (currentIndex === allSlides.length - 1) {
          currentIndex = 1;
        } else if (currentIndex === 0) {
          currentIndex = allSlides.length - 2;
        }
        track.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
      }
    });

    window.addEventListener('resize', () => {
      slideWidth = allSlides[currentIndex].getBoundingClientRect().width;
      track.style.transition = 'none';
      track.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
    });

    // Swipe
    let startX = 0;
    let isDragging = false;

    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const moveX = e.touches[0].clientX;
      const diff = moveX - startX;
      track.style.transition = 'none';
      track.style.transform = `translateX(-${(slideWidth * currentIndex) - diff}px)`;
    });

    track.addEventListener('touchend', (e) => {
      isDragging = false;
      const endX = e.changedTouches[0].clientX;
      const diff = endX - startX;

      if (Math.abs(diff) > 50) {
        if (diff < 0) nextButton.click();
        else prevButton.click();
      } else {
        goToSlide(currentIndex);
      }
    });
  }

  window.addEventListener('load', initCarousel); // Wait for images
});

  } catch(e) { console.error(e); }
})();
})();
